import * as React from 'react'
import '../css/styles.css'
import '../css/responsive.css'
import 'semantic-ui-css/semantic.min.css'
// import 'prismjs/themes/prism-okaidia.css'
import { Provider } from 'react-redux'
import { store } from '../store'
import Footer from './Footer'
import ResponsiveMenu from './ResponsiveMenu/ResponsiveMenu'

export interface LayoutProps {
  location: {
    pathname: string;
  }
  children: any
}

const Layout = (props: LayoutProps) => {
  const { pathname } = props.location

  return (
    <Provider store={store}>
      <>
        <div id='gallery-modal' />
        <ResponsiveMenu pathname={pathname}>
          <div style={{ paddingBottom: 60 }}>
            {props.children}
          </div>
          <Footer />
        </ResponsiveMenu>
      </>
    </Provider>
  )
}

export default Layout

export const withLayout = <P extends object>(WrappedComponent: React.ComponentType<P>) =>
  class WithLayout extends React.Component<P & LayoutProps> {
    render() {
      return (
        <Layout location={this.props.location}>
          <WrappedComponent {...this.props} />
        </Layout>
      )
    }
  }
